module.exports = __webpack_public_path__ + "static/img/Toys.5d919d9.png";